import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateUserForm } from '@/features/user/create-user-form'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/apk/list/create')({
  staticData: {
    meta: {
      title: 'Создать пользователя АПК',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создание пользователя АПК')}>
      <CreateUserForm onClose={close} />
    </Offcanvas>
  )
}
